import React from 'react'

const CountBadge = (props) => {
  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-100">
      <props.icon className="w-6 h-6"/>
      <span className="text-xl">{props.number}</span>
    </div>
  )
}

export default CountBadge